import { apiRoutes } from 'config/apiRoutes'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import type { TypesRes } from 'features/types/types/types.types'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchTypes = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)
	const query = getCurrentQuery()

	const { data: types, isPending: isTypesLoading } = useQuery<TypesRes>({
		queryKey: queryKeys.types.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.types(query ?? '')),
		enabled: !!auth.accessToken
	})

	return {
		types,
		isTypesLoading
	}
}
